import * as RadixSelect from '@radix-ui/react-select';

export type SelectProps = RadixSelect.SelectProps;

export const Select = RadixSelect.Root;
